import { useContext } from 'react';

import { GiftPassesEnabledContext } from './gift-passes-enabled-context';

export function useGiftPassesEnabled(): boolean | null {
  return useContext(GiftPassesEnabledContext);
}
